import { defineComponent } from "vue";
export default defineComponent({
    name: 'g-cookie-consent',
    data: () => ({
        showBanner: true,
        enableDefault: true,
        enableStatistik: false
    }),
    created() {
        this.showBanner = host.config.consentShowBanner || utils.isNullOrEmpty(utils.getCookieValue("288a.CookieStatistik"));
        this.enableStatistik = utils.getCookieValue("288a.CookieStatistik") == "yes";
    },
    methods: {
        setCookieAll() {
            this.enableStatistik = true;
            this.setCoockieCustom();
        },
        setCoockieCustom() {
            //Set
            document.cookie = host.config.consentCookie;
            //Custom
            if (this.enableStatistik) {
                document.cookie = host.config.statistikCookie;
            }
            else {
                document.cookie = utils.replace(host.config.statistikCookie, "=yes", "=no");
            }
            //Cookie
            host.config.consentShowBanner = false;
            this.showBanner = false;
            //Events
            this.$host.eventBus.emit("cookie_consent_changed");
        },
        setBannerVisible() {
            this.showBanner = true;
        }
    }
});
